import { z } from 'zod';


export const articlesProjectConfigSchema = z.object({
  id: z.string(),
});
